import { BitcoinRate } from "../models/bitcoin-rate.model";

export class PaymentOptionApiService {
  constructor(HttpService, SessionService) {
    'ngInject';

    this.HttpService = HttpService;
    this.SessionService = SessionService;
  }

  getBitcoinAdjustment() {
    return this.HttpService
      .get('/' + this.SessionService.getLocale() + `/payment-option/bitcoin-adjustment`)
      .then(payload => BitcoinRate.fromPayload(payload));
  }

  getBitcoinWithdrawalAdjustment() {
    return this.HttpService
      .get('/' + this.SessionService.getLocale() + `/payment-option/bitcoin-withdrawal-adjustment`)
      .then(payload => BitcoinRate.fromWithdrawalAdjustmentPayload(payload));
  }

  getBankPaymentOption() {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/payment-option/bank');
  }

  getPaymentOptionById(id) {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/payment-option/find/' + id);
  }

  linkBankAccountRequest(payload) {
    return this.HttpService.post('/' + this.SessionService.getLocale() + '/payment-option/bank/create', payload);
  }

  updateBankAccountRequest(payload) {
    return this.HttpService.post('/' + this.SessionService.getLocale() + '/payment-option/bank/update', payload);
  }

  deleteBankAccountRequest(payload) {
    return this.HttpService.post('/' + this.SessionService.getLocale() + '/payment-option/bank/delete', payload);
  }
}

export default PaymentOptionApiService;



// WEBPACK FOOTER //
// ./client/app/api/services/paymentoption.api.service.js